export const SITE = {
  name: "Oxygen Gym",
  full: "Oxygen Gym — Fitness & Gym",
  tagline: "Strong Body. Strong Mind. Strong Life.",
  city: "Bengaluru",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Classes", to: "/classes" },
  { label: "Branches", to: "/branches" },
  { label: "Pricing", to: "/pricing" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?q=85&w=2000&auto=format&fit=crop",
  barbell: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=85&w=1600&auto=format&fit=crop",
  pullup: "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?q=85&w=1200&auto=format&fit=crop",
  curl: "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?q=85&w=1200&auto=format&fit=crop",
  dumbbells: "https://images.unsplash.com/photo-1734630341082-0fec0e10126c?q=85&w=1200&auto=format&fit=crop",
  darkGym: "https://images.unsplash.com/photo-1770513649465-2c60c8039806?q=85&w=1600&auto=format&fit=crop",
  interiorLed: "https://images.unsplash.com/photo-1778828450059-f39d5bbb01af?q=85&w=1600&auto=format&fit=crop",
  interiorWide: "https://images.pexels.com/photos/9545909/pexels-photo-9545909.jpeg?auto=compress&cs=tinysrgb&w=1600",
  interiorEquip: "https://images.unsplash.com/photo-1778828494354-9b717d36dc99?q=85&w=1600&auto=format&fit=crop",
  bench: "https://images.unsplash.com/photo-1741156229623-da94e6d7977d?q=85&w=1600&auto=format&fit=crop",
  trainer1: "https://images.unsplash.com/photo-1611672585731-fa10603fb9e0?q=85&w=1200&auto=format&fit=crop",
  trainer2: "https://images.unsplash.com/photo-1683587056272-4f7f0abb1b38?q=85&w=1200&auto=format&fit=crop",
  trainer3: "https://images.unsplash.com/photo-1604480133435-25b86862d276?q=85&w=1200&auto=format&fit=crop",
  kettlebells: "https://images.unsplash.com/photo-1597076545399-91a3ff0e71b3?q=85&w=1200&auto=format&fit=crop",
  combat: "https://images.unsplash.com/photo-1676655079738-af54dfd6318e?q=85&w=1200&auto=format&fit=crop",
};

export const FALLBACK_BRANCHES = [
  {
    slug: "kg-halli",
    name: "KG Halli",
    label: "Oxygen Fitness and Gym — KG Halli",
    address: "Ezekiel Industrial Estate, Nagawara Main Rd, near Metro Woods Square, Kadugondanahalli, Bengaluru, Karnataka 560045",
    timings: "Mon–Sat 6:00 AM – 11:45 PM · Sunday Closed",
    phone: "+91 63603 67717",
    whatsapp: "916360367717",
    amenities: ["Strength Floor", "Cardio Deck", "Functional Zone", "Steam & Showers", "Locker Rooms", "Certified Trainers"],
    specialties: ["Bodybuilding", "Resistance Training", "Fitness"],
    image: IMAGES.interiorLed,
    maps_url: "https://share.google/D1m2kTQKjwLEjluxM",
    pricing: [
      { label: "Monthly", price: 1500, original: 1999 },
      { label: "Half-Yearly", price: 3000, original: 3500 },
      { label: "Yearly", price: 5000, original: 8999 },
    ],
  },
  {
    slug: "lingarajapuram",
    name: "Lingarajapuram",
    label: "Oxygen Gym — Lingrajpuram",
    address: "1st Floor, No. 12, 7th Cross Road, Kariyannapalya, Lingarajapuram, Bengaluru, Karnataka 560084",
    timings: "Mon–Sat 6:00 AM – 11:00 PM · Sunday Closed",
    phone: "+91 63603 67717",
    whatsapp: "916360367717",
    amenities: ["Cardio Theatre", "Group Class Studio", "CrossFit Rig", "Steam & Showers", "Locker Rooms", "Protein Bar"],
    specialties: ["Weight Loss", "Weight Control", "Cardio"],
    image: IMAGES.interiorWide,
    maps_url: "https://share.google/EUNHdNFBQHWJYR5Z8",
    pricing: [
      { label: "Monthly", price: 1500, original: 1999 },
      { label: "Half-Yearly", price: 3000, original: 3500 },
      { label: "Yearly", price: 5000, original: 8999 },
    ],
  },
  {
    slug: "lr-bande",
    name: "L R Bande",
    label: "Oxygen Gym — L R Bande",
    address: "Nanda Gokula Layout, Plot No 475/3, Shampura Main Rd, Appajappa Layout, Shampura, Kaval Bairasandra, Bengaluru, Karnataka 560032",
    timings: "Mon–Sat 6:00 AM – 11:00 PM · Sunday Closed",
    phone: "+91 70194 67717",
    whatsapp: "917019467717",
    amenities: ["Boxing Zone", "Strength Floor", "Cardio Deck", "Yoga Studio", "Steam & Showers", "Locker Rooms"],
    specialties: ["CrossFit", "Bodybuilding", "Resistance Training"],
    image: IMAGES.interiorEquip,
    maps_url: "https://share.google/QIl5hNnh3gUaAQ8Ir",
    pricing: [
      { label: "Monthly", price: 1800, original: 2499 },
      { label: "Half-Yearly", price: 5999, original: 8000 },
      { label: "Yearly", price: 7000, original: 12000 },
    ],
  },
];

export const CLASSES = [
  { id: "fitness", name: "Fitness", category: "General", intensity: 2, duration: "60 min", desc: "Full-body training for everyday strength, stamina and flexibility — the perfect starting point for any member.", image: IMAGES.interiorWide },
  { id: "weight-loss", name: "Weight Loss", category: "Weight Mgmt", intensity: 3, duration: "45 min", desc: "Fat-burning circuits and cardio intervals built to bring the number on the scale down — safely and steadily.", image: IMAGES.kettlebells },
  { id: "weight-control", name: "Weight Control", category: "Weight Mgmt", intensity: 3, duration: "50 min", desc: "Sustainable training plans that keep your weight exactly where you want it, month after month.", image: IMAGES.trainer3 },
  { id: "bodybuilding", name: "Bodybuilding", category: "Strength", intensity: 5, duration: "75 min", desc: "Hypertrophy splits, heavy compounds and machine work for serious, sculpted muscle building.", image: IMAGES.barbell },
  { id: "crossfit", name: "CrossFit", category: "Functional", intensity: 5, duration: "60 min", desc: "High-intensity WODs on the rig — strength, speed and endurance packed into one addictive hour.", image: IMAGES.combat },
  { id: "cardio", name: "Cardio", category: "Cardio", intensity: 3, duration: "40 min", desc: "Treadmills, rowers and bikes — build a heart and lungs that never quit on you.", image: IMAGES.interiorLed },
  { id: "resistance-training", name: "Resistance Training", category: "Strength", intensity: 4, duration: "60 min", desc: "Dumbbells, cables and machines — progressive resistance work for real, lasting strength.", image: IMAGES.curl },
];

export const SCHEDULE = [
  { day: "Mon", time: "06:00 AM", class: "Fitness", branch: "kg-halli" },
  { day: "Mon", time: "07:30 PM", class: "CrossFit", branch: "lr-bande" },
  { day: "Tue", time: "06:00 AM", class: "Bodybuilding", branch: "kg-halli" },
  { day: "Tue", time: "07:00 PM", class: "Cardio", branch: "lingarajapuram" },
  { day: "Wed", time: "06:30 AM", class: "Weight Loss", branch: "lingarajapuram" },
  { day: "Thu", time: "07:30 PM", class: "Resistance Training", branch: "kg-halli" },
  { day: "Fri", time: "06:00 AM", class: "Weight Control", branch: "lingarajapuram" },
  { day: "Sat", time: "08:00 AM", class: "CrossFit", branch: "lr-bande" },
];

export const GOALS = ["Weight Loss", "Weight Control", "Bodybuilding", "General Fitness", "Cardio & CrossFit", "Resistance Training"];
